import { render, staticRenderFns } from "./WidgetRenderFile-Layouts.vue?vue&type=template&id=0fe151b6&scoped=true&"
import script from "./WidgetRenderFile-Layouts.vue?vue&type=script&lang=js&"
export * from "./WidgetRenderFile-Layouts.vue?vue&type=script&lang=js&"
import style0 from "./WidgetRenderFile-Layouts.vue?vue&type=style&index=0&id=0fe151b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe151b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VIcon})
